module.exports = __webpack_public_path__ + "static/logo-transparent-b1e14fc09b45d46cb9346b71280dda3a.png";